module.exports = __webpack_public_path__ + "img/map_citygid_en.3274c2fe.jpg";